import FormMarcaModal from "../modals/FormMarcaModal";
import FormVisitaModal from "../modals/FormVisitaModal";
import "./cta.css";
import { Fragment, useState } from "react";

const Cta = () => {
  const [isMarcaOpen, setIsMarcaOpen] = useState(false);
  const [isVisitaOpen, setIsVisitaOpen] = useState(false);

  const handleMarcaOpen = () => setIsMarcaOpen(true);
  const handleVisitaOpen = () => setIsVisitaOpen(true);

  const options = [
    {
      id: 1,
      title: "¿Querés que distribuyamos tu marca?",
      description: [
        "Sumá tu marca a nuestra red y llevamos",
        "tu producto más lejos.",
      ],
      button: "Quiero sumar mi marca",
      onClick: handleMarcaOpen
    },
    {
      id: 2,
      title: "¿Tenés un negocio?",
      description: [
        "Llevamos los productos hasta tu puerta.",
        "Más variedad para tu negocio.",
      ],
      button: "Quiero que me visiten",
      onClick: handleVisitaOpen
    },
  ];

  return (
    <div className="cta">
      <div className="options-container">
        {options.map((option) => (
          <div key={option.id} className="option-card">
            <div>
              <p className="title-option">{option.title}</p>
              <p className="descrip-option">
                {option.description.map((line, index) => (
                  <Fragment key={index}>
                    {line}
                    {index < option.description.length - 1 && <br />}
                  </Fragment>
                ))}
              </p>
            </div>
            <div className="d-flex justify-content-center">
              <button onClick={option.onClick} className="btn-option" type="button">
                {option.button}
              </button>
            </div>
          </div>
        ))}
        <FormMarcaModal isOpen={isMarcaOpen} setIsOpen={setIsMarcaOpen} />
        <FormVisitaModal isOpen={isVisitaOpen} setIsOpen={setIsVisitaOpen} />
      </div>
    </div>
  );
};

export default Cta;
